import './index.css';
import Search from './components/Search';

function App() {
  return (
    <div className="container margin-top-bottom">
      <Search defaultWord="code"/>
    </div>
  );
}

export default App;
